import Logo from "@/common/Logo";
import StickyButton from "@/common/StickyButton";
import { logAnalyticsEvent } from "@/constants/amplitude";
import { WebEventProps, WebEventTypes } from "@/constants/event";
import { FitnessGoals } from "@/constants/fitnessGoal";
import { QUESTIONS_IDS } from "@/constants/questionsIds";
import { getReviewByGoal } from "@/constants/reviews";
import { usePrefix } from "@/hooks/usePrefix";
import i18n from "@/localization/i18next";
import { HandleNext } from "@/types/common";
import { useGender } from "@/utils/GenderProvider";

import useAnswers from "../../utils/useAnswers";

import PromoReviewBlock from "./PromoReviewBlock";

type PrimaryGoalType = FitnessGoals.GainMuscle | FitnessGoals.LoseWeight | FitnessGoals.GetActive;
interface PromoReviewsProps {
    handleNext: HandleNext;
}
const PromoReviews = ({ handleNext }: PromoReviewsProps) => {
    const { isFemale } = useGender();
    const { getEventType } = usePrefix();
    const { answers } = useAnswers();

    const handleContinue = () => {
        logAnalyticsEvent(WebEventTypes.RESULT_EVENT, {
            [WebEventProps.SCREEN]: getEventType("promo_reviews"),
        });
        handleNext();
    };

    return (
        <div className="mt-6 grid grow flex-col content-between gap-8">
            <div className="grid gap-10 md:gap-6">
                <div className="grid gap-4">
                    <Logo className="py-2" />
                    <div className="relative">
                        <div className="whitespace-pre-wrap text-zing-24-32 font-semibold text-white female:text-black">
                            {
                                getReviewByGoal(isFemale)[
                                    answers[QUESTIONS_IDS.PRIMARY_GOAL] as PrimaryGoalType
                                ].promoTitle
                            }
                        </div>
                    </div>
                </div>
                <PromoReviewBlock
                    {...getReviewByGoal(isFemale)[
                        answers[QUESTIONS_IDS.PRIMARY_GOAL] as PrimaryGoalType
                    ]}
                />
            </div>
            <StickyButton onClick={handleContinue} className="">
                <span className="normal-case">{i18n.t("continue")}</span>
            </StickyButton>
        </div>
    );
};

export default PromoReviews;
